import { MapUtils } from '../../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { isSameData } from '../../dto/data-model-utils.js';
import { Currency } from '../currency.js';
import { Price } from '../price.js';

export class DailyGenericIncomeStats extends DataModel {
  static readonly TYPE_ID: string = 'e2d36aca101a41769390d5b0e275e8eb';

  constructor(
    public income: Price,
    public orderCount: number,
    public ticketCount: number,
  ) {
    super();
  }

  get $typeId(): string {
    return DailyGenericIncomeStats.TYPE_ID;
  }

  static empty(currency: Currency): DailyGenericIncomeStats {
    return new DailyGenericIncomeStats(
        Price.zero(currency),
        0,
        0,
    );
  }

  static fromMap(
      context: SerializationContext,
      data: SerializedData,
  ): DailyGenericIncomeStats {
    return new DailyGenericIncomeStats(
        Price.decode(MapUtils.get<string>(data, 'income')),
        MapUtils.get<number>(data, 'orderCount'),
        MapUtils.get<number>(data, 'ticketCount'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      income: this.income.encode(),
      orderCount: this.orderCount,
      ticketCount: this.ticketCount,
    };
  }

  clone(): this {
    return new DailyGenericIncomeStats(
        this.income.clone(),
        this.orderCount,
        this.ticketCount,
    ) as this;
  }

  isSame(other: DailyGenericIncomeStats): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.income, this.income) &&
      other.orderCount === this.orderCount &&
      other.ticketCount === this.ticketCount;
  }
}

export class DailyGenericIncomeStatsBuilder extends DataModelBuilder<DailyGenericIncomeStats> {
  build(context: SerializationContext, map: SerializedData): DailyGenericIncomeStats {
    return DailyGenericIncomeStats.fromMap(context, map);
  }
}
